import { AttentionCircleIcon } from '@cash-me/react-components'

import * as S from './styles'

export const Warning = () => (
  <S.Wrapper>
    <AttentionCircleIcon size={18} color="var(--colors-primary-icon-strong)" />
    <S.Warning size="caption" weight="medium" color="var(--colors-neutral-text-contrast-default)">
      Não solicitamos nenhum tipo de depósito ou pagamento antecipado para aprovação da operação de empréstimo. Por
      razões de segurança, não enviamos e-mails com extensões (@gmail, @yahoo, @hotmail, etc.) que não sejam
      @cashme.com.br.
    </S.Warning>
  </S.Wrapper>
)
